const MessageTypes = {
    DID_LOAD: 'WdmExtDidLoad',

    DID_LOAD_USER: 'WdmExtDidLoadUser',

    SHOULD_SYNC_FRIENDS: 'WdmExtShouldSyncFriends',
    IS_SYNCING_FRIENDS: 'WdmExtIsSyncingFriends',
    FAILED_SYNCING_FRIENDS: 'WdmExtFailedSyncingFriends',
    DID_SYNC_FRIENDS: 'WdmExtDidSyncFriends',

    REQUEST: 'WdmExtShouldExecuteRequest',
    RESPONSE: 'WdmExtDidExecuteRequest',
};

module.exports = MessageTypes;
